import { FaSpinner } from "react-icons/fa";

export const Loader = (
    <div className="loader-container">
        <FaSpinner className="animate-spin text-3xl text-gray-50" size={50} />
    </div>
);